import { render } from "./ActionsDropdown.vue?vue&type=template&id=4707b77a&scoped=true"
import script from "./ActionsDropdown.vue?vue&type=script&lang=js"
export * from "./ActionsDropdown.vue?vue&type=script&lang=js"

import "./ActionsDropdown.vue?vue&type=style&index=0&id=4707b77a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4707b77a"]])

export default __exports__